import { usePayrollPlatformsQuery } from '@alice-financial/alice-sdk'

export interface PartnerExecutive {
  id: number
  firstName?: string | null
  lastName?: string | null
}

export interface PayrollPlatform {
  id: number
  name: string
  code: string
  partnerExecutives: PartnerExecutive[]
}

export const usePayrollPlatforms = () => {
  const { data, isLoading, error } = usePayrollPlatformsQuery()

  return {
    data: data?.payrollPlatforms,
    isLoading,
    error,
  }
}
